module.exports = __webpack_public_path__ + "static/img/project5.4c375df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project5.jpg
// module id = 746
// module chunks = 1